import { render, staticRenderFns } from "./InvestorConfirmationUserCard.vue?vue&type=template&id=4c6b4996&"
import script from "./InvestorConfirmationUserCard.vue?vue&type=script&lang=js&"
export * from "./InvestorConfirmationUserCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports